import React from 'react';
import './existing-topics-styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";
import { useEffect } from "react";
import {
  faStethoscope,
  faCalendarCheck,
  faMobileAlt,
  faUserClock,
  faTools,
  faUsers,
  faCloud,
  faRobot,
  faShieldAlt,
  faPhishing,
  faLock,
  faMicrochip,
  faCode,
} from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";

export const ExcitingTopics = () => {

  const getSlidesToShow = (width) => {
    if (width > 1300) {
      return 3;
    }
    else if (width > 1024) {
      return 3;
    } else if (width > 768) {
      return 2;
    } else {
      return 1;
    }
  };
  const [slidesToShoww, setSlidesToShoww] = useState(getSlidesToShow(window.innerWidth));


  useEffect(() => {
    const handleResize = () => {
      setSlidesToShoww(getSlidesToShow(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShoww,
    slidesToScroll: 1

  };

  return (
    <section className='topics-section pb-4 pt-1'>
      <div className='topics-container '>
        <div className='existion-session-container'  >
          <h2 className='expect-heading head-font bar'>
            Exciting Session Topics to <span className='text-theme head-font'> Look Forward</span> To
          </h2>
          <p className='topics-intro mb-4'>
            We're bringing together a diverse lineup of topics designed to keep
            you up-to-date with the latest advancements and tools.
          </p>
        </div>

        <div className='topics-grid1'>
          <Slider {...settings}>
            <div>
              <div className='bg-teal topic-item d-flex align-items-center mb-4' >
                <h5 className='topics-intro text-danger mb-0' style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  fontSize: "1.6rem",
                }}>
                  <b className='text-white head-font'>Here’s a sneak
                    peek at what’s in store</b>
                </h5>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faStethoscope} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Epic/Clinical Applications</b>
                  Enhance file sharing and team collaboration
                </p>
              </div>
            </div>
            <div >
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faCalendarCheck} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Fast Pass:</b> Revolutionize patient scheduling by automatically
                  notifying patients of earlier available appointments</p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faMobileAlt} className='topic-icon' />
                  </div>
                </div>
                <p> <b>eCheck-In:</b> Empower patients to complete pre-visit tasks on their
                  mobile devices
                </p>
              </div>
            </div>
            <div>
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faUserClock} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Guided Scheduling:</b> Ensure patients are scheduled with the right
                  provider, at the right time
                </p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faTools} className='topic-icon' />
                  </div>
                </div>
                <p>
                  <b>Microsoft Tools & Features</b>
                  Enhance file sharing and team collaborations
                </p>
              </div>
            </div>
            <div>
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faUsers} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Microsoft Teams:</b> Maximize communication and collaboration with this
                  powerful platform
                </p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faCloud} className='topic-icon' />
                  </div>
                </div>
                <p> <b>OneDrive & SharePoint:</b> Enhance file sharing and team collaboration
                </p>
              </div>
            </div>
            <div>
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faRobot} className='topic-icon' />
                  </div>
                </div>
                <p> <b> Hyperautomation:</b> Learn how automating business and IT processes
                  boosts efficiency
                </p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faShieldAlt} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Cybersecurity Best Practices:</b> Safeguard our systems and patient data
                </p>
              </div>
            </div>
            <div>
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faLock} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Let’s Go Phishing!:</b> Spot and prevent phishing attacks that target
                  healthcare organizations
                </p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faLock} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Social Engineering Defense:</b> Recognize and avoid common social
                  engineering tactics
                </p>
              </div>
            </div>
            <div>
              <div className='topic-item mb-4'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faMicrochip} className='topic-icon' />
                  </div>
                </div>
                <p> <b>Digital Scribe Abridge:</b> See AI transcribe provider-to-patient
                  conversations
                </p>
              </div>
              <div className='topic-item'>
                <div className='icon-outer'>
                  <div className='icon-inner'>
                    <FontAwesomeIcon icon={faCode} className='topic-icon' />
                  </div>
                </div>
                <p> <b>AI Coding: </b> Explore how AI transforms medical coding
                </p>
              </div>
            </div>
          </Slider>

        </div>
      </div>
    </section>
  );
};
